import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const FieldRetourMovePalletRoute: Route = {
  path: 'field-retour/update',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/move-pallet.component').then((m) => m.FieldRetourMovePalletComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
